import { ManagementHttpService } from './../http/management-http.service';
import { AccountService } from './../services/account.service';
import { UserHttpService } from './../http/user-http.service';
import { forkJoin } from 'rxjs';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ProductHttpService } from '../http/product-http.service';
import { BranchHttpService } from '../http/branch-http.service';

@Injectable({
    providedIn: 'root',
})
export class ProductAvailabiltyHttpResolverService implements Resolve<any> {
    constructor(
        private productHttpService: ProductHttpService,
        private userHttpService: UserHttpService,
        private managementHttpService: ManagementHttpService,
        private accountService: AccountService,
        private branchesHttpService: BranchHttpService
    ) {}
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let getProductAvailabilityState = this.managementHttpService.getProductAvailabilityState(this.accountService.currentUser.branchId);
        let branches = this.branchesHttpService.getAllBranches();
        return forkJoin([getProductAvailabilityState, branches]);
    }
}
